import React from 'react'

import FinalQuestionsContainer from 'src/containers/AutomaticPlan/FinalQuestions'

const FinalQuestionsPage: React.FC = () => {
  return <FinalQuestionsContainer />
}

export const PATH = '/automatic-plan/final-questions/:id' as const
export default FinalQuestionsPage
